<template>
  <div class="app-header backfff">
    <div class="container">
      <a href="/" class="banner font">QJGAME</a>
      <el-menu router :default-active="activeIndex" class="el-menu-horizontal  hidden-xs" mode="horizontal">
        <el-menu-item index="/">首页</el-menu-item>
        <el-submenu :show-timeout="0" :hide-timeout="0" v-for="first in category" :key='first.categoryId'
                    class="el-submenu" :index="first.path"
                    v-if="first.children">
          <template slot="title">{{ first.categoryName }}</template>
          <el-menu-item v-for="second in first.children" :key='second.categoryId' :index="second.path">
            {{ second.categoryName }}
          </el-menu-item>
        </el-submenu>
        <el-menu-item index="/demand">反馈</el-menu-item>
      </el-menu>
      <div class="right">
        <div class="search-btn hidden-xs" @click="openSearch()"><i class="el-icon-search"></i> 搜索</div>
        <i class="el-icon-search visible-xs" @click="openSearch(true)"></i>
        <van-icon class="visible-xs" @click="openMenu" name="wap-nav"/>
        <div class="header_login_reg hidden-xs" v-if="!isLogin">
          <router-link to='/login'>登录</router-link>
          <span style="padding: 0 10px">|</span>
          <router-link to='/register'>注册</router-link>
        </div>
        <div class="header_user hidden-xs" v-if="isLogin">
          <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" router>
            <el-submenu :show-timeout="0" :hide-timeout="0" :index="'/user'">
              <template slot="title">
                <img style="object-fit: cover"
                     v-lazy="userInfo.head?userInfo.head:'https://file.qjzx.top/upload/image/default-head.png'">
                <span class="header_user_nickname text-overflow">{{ userInfo.nickname }}</span>
              </template>
              <el-menu-item :index="'/user'">个人中心</el-menu-item>
              <el-menu-item :index="'/loginout'">退出登录</el-menu-item>
            </el-submenu>
          </el-menu>
        </div>
        <el-tooltip class="item" effect="dark" content="开启或关闭夜间模式" placement="bottom">
          <i :class="themeIcon" @click="changeTheme"></i>
        </el-tooltip>
      </div>
    </div>
    <el-dialog
        class="search-dialog"
        :fullscreen="searchFullscreen"
        :visible.sync="searchShow"
        center
        append-to-body
        :close-on-click-modal="false"
        :show-close="true"
        :before-close="closeSearch">
      <div slot="title" class="head">
        <el-input class="search-input" placeholder="请输入关键字" prefix-icon="el-icon-search" @input="inputSearch" clearable
                  v-model="searchData.query.title">
        </el-input>
      </div>
      <div class="search-data-list">
        <data-list :data-list="searchData.dataList" :loading="searchData.loading"/>
        <pagination v-if="!searchData.loading && searchData.dataList.length > 0 && searchData.pages > 1"
                    :total="searchData.total" @pagination="changePage"
                    layout="total, prev, pager,next"
                    :page-num="searchData.query.pageNum"
                    :page-size="searchData.query.pageSize"/>
        <div class="search-empty" v-if="searchData.total === 0">
          没有相关结果 "<strong>{{ searchData.query.title }}</strong>"
        </div>
      </div>
    </el-dialog>
    <van-popup :closeable="false" class="van-popup" position="left" v-model="menuShow" style="width:60%;height: 100%">
      <el-menu @select="selectMenu" router :default-active="activeIndex" class="el-menu-vertical">
        <el-menu-item index="/">首页</el-menu-item>
        <el-submenu v-for="first in category" :key='first.categoryId' class="el-submenu" :index="first.path"
                    v-if="first.children">
          <template slot="title">{{ first.categoryName }}</template>
          <el-menu-item v-for="second in first.children" :key='second.categoryId' :index="second.path">
            {{ second.categoryName }}
          </el-menu-item>
        </el-submenu>
        <el-menu-item v-for="first in category" :key='first.categoryId' :index="first.path"
                      v-if="!first.children">{{ first.categoryName }}
        </el-menu-item>
        <el-menu-item index="/demand">反馈</el-menu-item>
      </el-menu>
      <div class="left-user">
        <div class="header_login_reg" v-if="!isLogin">
          <router-link to='/login'>登录</router-link>
          <span style="padding: 0 10px">|</span>
          <router-link to='/register'>注册</router-link>
        </div>
        <div class="user-info" v-if="isLogin">
          <el-avatar :size="60" :src="userInfo.head"></el-avatar>
          <span class="user-nickname">{{userInfo.nickname}}</span>
          <div class="header_login_reg">
            <a href='/user'>个人中心</a>
            <span style="padding: 0 10px">|</span>
            <a href='/loginout'>注销</a>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";
import * as articleApi from "@/api/article";
import DataList from "@/views/article/components/data-list-small.vue";
import Pagination from "@/components/Pagination/index.vue";

export default {
  components: {Pagination, DataList},
  data() {
    return {
      searchShow: false,
      searchFullscreen: false,
      menuShow: false,
      activeIndex: '/',
      searchData: {
        loading: false,
        query: {
          pageNum: 1,
          pageSize: 20,
          title: '',
          orderBy: 'updateTime',
          sort: 'desc',
        },
        dataList: [],
        total: -1,
        pages: -1
      }
    }
  },
  computed: {
    themeIcon: function () {
      if (this.theme === 'light') {
        return "el-icon-moon";
      } else {
        return "el-icon-sunny";
      }
    },
    nightValue: function () {
      return this.theme !== 'light';
    },
    ...mapState(['isLogin', 'category', "userInfo", "theme"]),
    ...mapActions(['getCategory', 'getUserInfo']),
  },
  watch: {
    '$route'(to, from) {
      this.activeIndex = this.$route.path;
    },
  },
  async mounted() {
    await this.getUserInfo;
    this.activeIndex = this.$route.path;
    let theme = localStorage.getItem("theme");
    if (theme) {
      this.updateTheme(theme)
    }
    await this.getCategory;
  },
  methods: {
    ...mapMutations(["updateTheme"]),
    changeTheme() {
      if (this.theme === 'light') {
        this.updateTheme("dark");
      } else {
        this.updateTheme("light");
      }
      localStorage.setItem("theme", this.theme);
    },
    openSearch(val) {
      this.searchShow = true;
      this.searchFullscreen = val;
    },
    openMenu() {
      this.menuShow = true;
    },
    closeSearch(done) {
      done();
      this.searchData = this.$options.data().searchData
    },
    inputSearch(){
      this.searchData.query.pageNum = 1;
      this.search();
    },
    search() {
      let title = this.searchData.query.title;
      title = title.replaceAll(" ", "")

      if (!title) {
        this.searchData.dataList = [];
        this.searchData.total = -1;
        return;
      }
      this.searchData.loading = true;
      articleApi.listArticle(this.searchData.query).then(res => {
        this.searchData.dataList = res.data.list;
        this.searchData.total = res.data.total;
        this.searchData.pages = res.data.pages;
      }).finally(() => {
        setTimeout(() => {
          this.searchData.loading = false;
        }, 0)
      })
    },
    changePage(current) {
      this.searchData.query.pageNum = Number.parseInt(current);
      this.search();
    },
    selectMenu(index, indexPath) {
      this.menuShow = false;
    }
  }
}
</script>


<style lang="scss">
.search-dialog {
  .el-dialog {
    display: flex;
    flex-direction: column;
    background-color: --color(--p-white);
    color: --color(--p-text-34);
    padding: 20px;
    width: 90%;
    max-width: 900px;
    max-height: calc(100% - 250px);
    border-radius: $base-border-radius;
    @media (max-width: 767px) {
      width: 100%;
      max-height: none;
      border-radius: 0;
      padding: 10px;
    }

  }

  .el-dialog__body {
    flex: 1;
    overflow-y: auto;
  }

  .el-dialog__header, .el-dialog__body {
    padding: 0;
  }

  .head {
    margin-top: 40px;
    padding-bottom: 10px;

    input, .el-input-group__prepend {
      background-color: --color(--p-white);
    }

    .el-input__inner {
      color: --color(--p-text-34);
    }
  }

  .search-empty {
    text-align: center;
    color: --color(--p-text-34);
  }
}

.van-popup {
  background-color: --color(--p-white);
  .left-user{
    border-top: 1px solid #e5e5e5;
    padding: 20px;
    .header_login_reg{
      text-align: center;

      color: --color(--p-text-34);
      a {
        color: --color(--p-text-34);
      }
    }
  }
  .user-info{
    align-items: center;
    display: flex;
    flex-direction: column;
    .user-nickname{
      display: inline-block;
      margin-bottom: 10px;
      color: $base-color-primary;
    }
  }
}

.app-header {
  width: 100%;
  overflow: hidden;
  position: fixed;
  top: 0;
  z-index: 999;
  border-bottom: 1px solid --color(--p-border-color);
  //box-shadow: 0 8px 16px -4px rgba(44,45,48,0.047);

  @media(max-width: 767px) {
    border-bottom: 1px solid --color(--p-border-color);
    box-shadow: none;
  }

  .banner {
    font-size: 20px;
    font-weight: 700;
    float: left;
    height: 60px;
    line-height: 60px;
  }

  .el-menu-horizontal {
    float: left;
    margin-left: 40px;
  }

  .el-menu-vertical {
    border-right: none;
  }

  .el-menu, .el-menu {
    border-bottom: --color(--p-white);
    background-color: --color(--p-white);


    .el-menu-item.is-active {
      background-color: --color(--p-white);
      color: $base-color-primary;
    }

    .el-menu-item:hover {
      background-color: --color(--p-white);
      color: $base-color-primary;
    }

    .el-submenu .el-submenu .is-active {
      color: $base-color-primary;
    }

    .el-submenu .el-submenu__title:hover {
      background-color: --color(--p-white);
      color: $base-color-primary;
    }

    li {
      color: --color(--p-text-34);
    }

    li .el-submenu__title {
      color: --color(--p-text-34);
    }
  }

  .right {
    float: right;
    height: 60px;
    display: flex;
    align-items: center;

    .header_login_reg {
      margin-left: 16px;
      color: --color(--p-text-34);

      a {
        color: --color(--p-text-34);
      }

      a:hover {
        color: $base-color-primary;
      }
    }

    .header_user {
      float: right;
      height: 60px;
      line-height: 60px;
      color: #333;

      .header_user_nickname {
        margin-left: 10px;
        max-width: 100px;
        display: inline-block;
      }

      a {
        transition: 0.2s;
      }

      img {
        width: 30px;
        height: 30px;
        border-radius: 50%;
      }
    }

    i {
      cursor: pointer;
      font-size: 18px;
      margin-left: 16px;
      color: --color(--p-text-34);
    }

    .search-btn {
      border: 1px solid --color(--p-bg-f8);
      background: --color(--p-bg-f8);
      color: --color(--p-text-99);
      padding: 10px;
      font-size: 13px;
      width: 160px;
      cursor: pointer;
      border-radius: $base-border-radius;
      box-sizing: border-box;
      transition: 0.2s;

      i {
        font-size: 14px;
      }

      &:hover {
        border: 1px solid $base-color-primary;
      }
    }
  }
}

.el-menu--popup {
  background-color: --color(--p-white);
}

.el-menu--horizontal .el-menu .el-menu-item {
  background-color: --color(--p-white);
  color: --color(--p-text-34);
}

.el-menu--horizontal .el-menu .el-menu-item.is-active {
  color: $base-color-primary;
}

.el-menu--horizontal .el-menu .el-menu-item:hover {
  color: $base-color-primary;
}

.el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
  color: $base-color-primary;
}

.el-menu--horizontal > .el-menu-item.is-active {
  border-bottom: --color(--p-white);
}

.el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
  border-bottom: --color(--p-white);
}
</style>

<style lang="scss" scoped>
</style>
